<template>
  <div id="payment-form" class="form">
    <div id="success" class="border p-3 text-center w-100" v-if="formSuccess">Your payment was successfully taken. Thank you!</div>
    <form ref="form" class="form" enctype="multipart/form-data" @submit.prevent="" v-if="formDone != true">
      <div id="errors" class="border p-3 text-center font-weight-bold mb-3" v-if="errors != null">There was an error submitting your request: {{ errors }}</div>
      <Field v-for="field in fields" v-bind:key="field.slug" :field="field" :fields="fields" v-on:updated="updateFields"></Field>
      <div class="form-item full buttons">
        <input type="submit" value="Submit Payment" class="button mr-2" v-if="disableSubmit != true" @click="submitForm()" />
      </div>
    </form>
    <div id="submitting" class="popup" v-if="disableSubmit">
      <div class="message">Submitting your payment. One moment while we process your information.</div>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Field'
import PaymentFieldData from '@/PaymentFieldData.js'
import Api from '@/Api.js';

export default {
  name: 'PaymentForm',
  components: {
    Field
  },
  props: [],
  data() {
    return {
      formSuccess: false,
      formDone: false,
      disableSubmit: false,
      errors: null,
      files: null,
      fileUrl: '',
      fields: PaymentFieldData
    };
  },
  methods: {
    submitForm(addMore = false) {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return false;
      }
      this.disableSubmit = true;
      let formData = new FormData();
      let fields = JSON.stringify(this.fields);
      formData.append('fields', fields);
      formData.append('type', 1);
      this.errors = null;
      Api.post(
        'form/save',
        formData,
        {
          'Content-Type': 'multipart/form-data'
        }
      ).then(response => {
        this.disableSubmit = false;
        if (response.data.success == true) {
          if (addMore == true) {
            this.formSuccess = true;
            this.resetFieldsForMore();
            setTimeout(() => {
              document.querySelector("#payment-form").scrollIntoView({
                behavior: 'smooth'
              });
            }, 500);
          } else {
            this.formSuccess = true;
            this.formDone = true;
          }
        } else {
          this.formSuccess = false;
          this.errors = response.data.message;
          setTimeout(() => {
            document.querySelector("#errors").scrollIntoView({
              behavior: 'smooth'
            });
          }, 500);
        }
      });
    }
  }
}
</script>

<style>

</style>
